import { getResponsiveProp, responsive } from '../helpers';
/**
 * Get responsive text align styles.
 * @beta Should not be used in production, as this might change.
 */
export function responsiveTextAlignStyle(props) {
    const { theme } = props;
    return responsive(theme.sanity.media, getResponsiveProp(props.$align), (textAlign) => {
        return { textAlign };
    });
}
//# sourceMappingURL=textAlignStyle.js.map